export type CodexProviderTab = 'native' | 'template';

export type CodexProviderSettingsState = {
  activeTab: CodexProviderTab;
  nativeProvider: string;
  templateProvider: string;
};

export function normalizeCodexSettingsMode(mode: unknown): 'local' | 'native_provider' | 'template' {
  const value = String(mode || '').trim();
  if (value === 'native_provider' || value === 'template') return value;
  if (value === 'unified' || value === 'shared' || value === 'custom') return 'template';
  return 'local';
}

export function buildCodexProviderSettingsState(config: any, templateFallback = ''): CodexProviderSettingsState {
  const mode = normalizeCodexSettingsMode(config?.mode);
  return {
    activeTab: mode === 'template' ? 'template' : 'native',
    nativeProvider: mode === 'native_provider' ? String(config?.nativeProvider || '').trim() : '',
    templateProvider: mode === 'template'
      ? String(config?.sharedTemplate || templateFallback || '').trim()
      : String(templateFallback || '').trim(),
  };
}

export function buildCodexSaveConfig(state: CodexProviderSettingsState): any {
  if (state.activeTab === 'template') {
    return {
      mode: 'template',
      legacyMode: '',
      sharedTemplate: state.templateProvider,
      nativeProvider: '',
      enableSearch: false,
    };
  }
  const nativeProvider = String(state.nativeProvider || '').trim();
  return {
    mode: nativeProvider ? 'native_provider' : 'local',
    legacyMode: '',
    sharedTemplate: '',
    nativeProvider,
    enableSearch: false,
  };
}

export function codexNativeProviderMissing(savedProvider: string, providers: string[]): boolean {
  const provider = String(savedProvider || '').trim();
  if (!provider) return false;
  return !providers.includes(provider);
}
